var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3317 14.8329H17.1733L16.7627 14.4688C17.6791 13.49 18.3488 12.3369 18.724 11.0923C19.0992 9.8476 19.1705 8.54207 18.9329 7.2691C18.2437 3.52092 14.8417 0.527765 10.7359 0.0693544C9.29245 -0.098551 7.82633 0.0393846 6.44976 0.472606C5.07319 0.905828 3.82265 1.62285 2.79383 2.56881C1.765 3.51477 0.985173 4.6646 0.514004 5.9303C0.0428345 7.19601 -0.107183 8.54404 0.0754294 9.87125C0.573994 13.6464 3.82933 16.7744 7.90583 17.4081C9.2903 17.6266 10.7102 17.561 12.0639 17.216C13.4176 16.871 14.6716 16.2552 15.7362 15.4126L16.1321 15.7901V16.8553L22.3642 22.5854C22.9654 23.1382 23.9479 23.1382 24.5491 22.5854C25.1503 22.0326 25.1503 21.1293 24.5491 20.5765L18.3317 14.8329ZM9.5335 14.8329C5.88224 14.8329 2.93484 12.1229 2.93484 8.76567C2.93484 5.40849 5.88224 2.69847 9.5335 2.69847C13.1847 2.69847 16.1321 5.40849 16.1321 8.76567C16.1321 12.1229 13.1847 14.8329 9.5335 14.8329Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.4f9f056765dc4d2450e5c62eeda93627.svg";
export { ForwardRef as ReactComponent };